<template>
    <div v-loading="isBusy">
        <el-form ref="form" :model="form" :rules="rules" label-position="top" label-width="auto">
            <el-form-item label="The contact will expire from this group in X days" prop="expiry_period">
                <el-input-number
                    :precision="0"
                    :min="1"
                    v-model="form.expiry_period"
                ></el-input-number>
            </el-form-item>
        </el-form>
        <div>
            <button class="btn btn-create" @click="store">Save</button>
        </div>
    </div>
</template>

<script>
  import ValidatorMixin from "../../mixins/validator";

  export default {
    props: {
      initialModel: Object,
    },

    data() {
      return {
        isBusy: false,
        form: {
          expiry_period: null,
        },
        rules: {
          expiry_period: [{validator: this.fieldExternalValidator}],
        },
        model: {},
        errors: {},
      };
    },

    computed: {
      /**
       * @return {String}
       */
      storeUrl() {
        return this.model.store_url;
      },
    },

    watch: {
      /**
       * @return {Object}
       */
      model(value) {
        this.initForm(value);
      },

      /**
       * @return {Object}
       */
      initialModel: {
        handler: function (value) {
          this.model = _.assign({}, this.initialModel);
        }
      },
    },

    methods: {
      /**
       * @return {Object}
       */
      getForm() {
        return  {
          expiry_period: this.hoursToSeconds(this.form.expiry_period),
          _method: 'PATCH',
        };
      },

      /**
       * @return {undefined}
       */
      store() {
        this.isBusy = true;
        axios.post(this.storeUrl, this.getForm())
          .then(this.storeSuccess)
          .catch(this.handleErrorResponse)
          .finally(() => this.isBusy = false);
      },

      /**
       * @param {Object} data
       * @param {String|undefined} message
       * @return {undefined}
       */
      storeSuccess({data: {data: model, message}}) {
        message && this.$message.success(message);
        this.$emit('updated', {model});
      },

      /**
       * @param {Object} error
       */
      handleErrorResponse({response: {data: {errors, message}, status}}) {
        if (status === 422 && errors) {
          this.errors = errors;
          this.$refs.form.validate(() => null);
        } else if (message && _.isString(message)) {
          this.$message.error(message);
        }
      },

      /**
       * @param {Object} model
       */
      initForm(model) {
        this.form = {
          expiry_period: this.secondsToHours(model.expiry_period),
        };
      },

      /**
       * @param {*} value
       * @return {number|null}
       */
      secondsToHours(value) {
        if (_.isNull(value) || _.isUndefined(value)) {
          return undefined;
        }

        return _.ceil(Number(value) / (60 * 60 * 24));
      },

      /**
       * @param {*} value
       * @return {number|null}
       */
      hoursToSeconds(value) {
        if (_.isNull(value) || _.isUndefined(value)) {
          return null;
        }

        return _.ceil(Number(value)) * (60 * 60 * 24);
      }
    },

    mounted() {
      //
    },

    mixins: [
      ValidatorMixin
    ]
  }
</script>

